import { toast } from 'react-toastify';

export const notifyEditPermissionDenied = (authUser) => {
  toast.error(authUser?.token ? 'Insufficient rights' : 'Please authenticate', { position: 'bottom-left' });
};
